module.exports = __webpack_public_path__ + "static/media/grad.9f7bd7c6.svg";